export default __webpack_public_path__ + "static/media/Progressive_Labs_logo.c9f910f6.png";